var map = {
	"./assets/ajinomotoWheel/pointeur.png": 3266,
	"./assets/bmiValentinesDayWheel/pointeur.png": 3706,
	"./assets/christmasFortuneWheel/pointeur.png": 1705,
	"./assets/classicWheel/pointeur.png": 7033,
	"./assets/estivalWheel/pointeur.png": 5073,
	"./assets/grippleWheel/pointeur.png": 7119,
	"./assets/losteWheel/pointeur.png": 7920,
	"./assets/sirhaWheel/pointeur.png": 1057,
	"./assets/stickAndPlayWheel/pointeur.png": 6123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5369;